import {IVolumes} from "../types/IVolumes";

export const defaultVolumes: IVolumes = {
  isBackingTrackMuted: false,
  backingTrack: .8,
  isCountInMuted: false,
  countIn: .3,
  isMetronomeMuted: false,
  metronome: .8,
  piano: .8,
  video: .8
};